export default __webpack_public_path__ + "static/media/Aida Alibegović.2c8d9eb3.jpg";